import React from 'react';

const SubmitButton = ({ handleSubmit, classNames, isDisabled = false, error, label }) => {
  return (
    <>
      <button
        type="button"
        onClick={handleSubmit}
        className={classNames}
        disabled={isDisabled}
      >
        {label}
      </button>
      {error && <p className="body-3 mt-1 text-center text-error">{error}</p>}
    </>
  );
};

export default SubmitButton;
